import create from './RegistrationCreate';
import list from './RegistrationList';
import edit from './RegistrationEdit';
import icon from '@material-ui/icons/HowToReg';
import show from './RegistrationView'


export default{ 
    create,
    list,
    edit,
    show,
    icon
};
